











import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import _ from "lodash";
import EventBus from "front-component/EventBus";

@Component({})
export default class SelectSearch extends Vue {
    @Prop({ default: "" }) public value!: string;
    @Prop() public filterName!: string;
    @Prop() public filters!: any;
    @Prop( {default: "keyword"}) public placeholder!: string;

    private filter: string = "";

    @Watch("value") private updateValue() {
        this.filter = this.value;
    }

    private mounted() {
        this.filter = this.value;
    }

    private updateFilter(): void {
        EventBus.$emit("update-filter", _.set({}, this.filterName, this.filter));
    }
}
